angular.module('ecrd').factory('RecordAuditFields', [
    'Event',
    function(Event) {
        var fieldsInfo = {};

        return {
            EVENTS: {
                INFO_UPDATED: 'recordAuditFieldsInfoUpdated',
            },
            clear: function() {
                fieldsInfo = {};
            },
            init: function(data) {
                this.clear();
                this.reload(data);
            },
            reload: function(data) {
                var updated = [];
                angular.forEach(data, function(uid) {
                    if (!fieldsInfo[uid]) {
                        fieldsInfo[uid] = true;
                        updated.push(uid);
                    }
                });
                if (updated.length) {
                    Event.trigger(this.EVENTS.INFO_UPDATED, updated);
                }
            },
            fieldIconIsEnabled: function(fieldUId) {
                return !!fieldsInfo[fieldUId];
            },
        };
    },
]);